import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import * as S from '@/components/BookmarksEmpty/BookmarksEmpty.styles';
import { useIsTopBannerVisible } from '@/hooks/useIsTopBannerVisible';

export const BookmarksEmpty = () => {
  const { t } = useTranslation();
  const isTopBannerVisible = useIsTopBannerVisible();

  return (
    <S.Box
      data-testid="bookmarks-empty"
      $isTopBannerVisible={isTopBannerVisible}
    >
      <IconBox
        $filename="bookmarks-empty.png"
        $width={207}
        $height={200}
        $iconWidth={207}
        $iconHeight={200}
      />
      <S.Text $variant="1">{t('pages.bookmarks.bookmarks_empty_text')}</S.Text>
    </S.Box>
  );
};
